/* IL CANCELLO DEL SITO (3 novembre 2026): se il servizio dice che questo
   dominio non ha una skin accesa (eliminata o disattivata dal backoffice),
   al posto del sito c'e' una pagina sola, «non disponibile». Si accorge
   anche di una risposta arrivata dopo il primo disegno (ascoltaSkin). */
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {ascoltaSkin, sitoSpento} from '../skin';

export function SitoNonDisponibile() {
  const {t} = useTranslation();
  return (
    <main role="main" style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', gap: 12, padding: 24, textAlign: 'center',
      background: '#0b0f17', color: '#e6e9ef', fontFamily: 'system-ui, sans-serif',
    }}>
      <h1 style={{fontSize: 24, margin: 0}}>{t('Sito non disponibile')}</h1>
      <p style={{margin: 0, maxWidth: 420, color: '#9aa3b2'}}>{t('Questo indirizzo al momento non è attivo.')}</p>
    </main>
  );
}

export default function Cancello({children}) {
  const [spento, setSpento] = useState(sitoSpento());
  useEffect(() => ascoltaSkin(() => setSpento(sitoSpento())), []);
  return spento ? <SitoNonDisponibile/> : children;
}
